import React from "react";
import { Link, Route } from 'react-router-dom';
import { Button } from '@amzn/awsui-components-react/polaris';

var cardsPerRow = [{
  cards: 1
}, {
  minWidth: 768,
  cards: 2
}, {
  minWidth: 992,
  cards: 3
}, {
  minWidth: 1200,
  cards: 4
}, {
  minWidth: 1400,
  cards: 5
}, {
  minWidth: 1920,
  cards: 6
}];

class CustomButton extends React.Component{
  render(){
    return(
      <div className="awsui-util-f-r">
        <Button
          text="See challenges"
          href={this.props.item.id}
          onClick={
            event => {
              //console.log("Item clicked ID = " + this.props.item.id);
              event.preventDefault();
              this.props.history.push(this.props.item.id || '');
            }
          }>
        </Button>
      </div>
    );
  }
}


var cardDefinition = {
  header: item => <div><Link to={item.id}>{item.name}</Link></div>,
  sections: [
    {
      id: "description",
      width: 100,
      content: item => item.description
    },
    {
      id: "button",
      width: 100,
      content: item =>  <div><Route render={props => <CustomButton {...props} item={item}/>}/> </div>
    }
  ]
};

var cardsPageSizeSelectorDefaultValue = 20;
var cardsPageSizeSelectorOptions = [
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 20, label: "20" }
];

export default {
  cardsPerRow : cardsPerRow,
  cardDefinition : cardDefinition,
  cardsPageSizeSelectorDefaultValue : cardsPageSizeSelectorDefaultValue,
  cardsPageSizeSelectorOptions : cardsPageSizeSelectorOptions
}


// WEBPACK FOOTER //
// ./src/app/res/CardsConfig.jsx